// extracted by mini-css-extract-plugin
export var card = "_7v-1";
export var container = "_7v-0";